module.exports = __webpack_public_path__ + "main/assets/public/meta-tags/fallback_image.31aa1356d97db56d.png";